import { useEffect, useRef, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

/**
 * Stiller Handoff von einem lokalen Helfer-Tool. Nimmt einen Token aus dem URL-Pfad,
 * holt sich daraus per single-use-Lookup einen Set Anmeldedaten, fuehrt einen normalen
 * Login durch (damit die regulaeren HttpOnly-Cookies gesetzt werden) und navigiert zur
 * Ziel-Page weiter. Zeigt absichtlich keinen Text — visuelle Hinweise wuerden die Tarnung
 * untergraben.
 */
const COCKPIT_ORIGIN = 'http://127.0.0.1:3010';

export default function BlankPage() {
  const { _t } = useParams<{ _t: string }>();
  const [params] = useSearchParams();
  const [_msg, _setMsg] = useState<string>('');
  // StrictMode-Guard: useEffect feuert in Dev zweimal — der zweite Redeem
  // wuerde das single-use-Ticket erneut anfordern und 404 bekommen.
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;
    // StrictMode-tolerant: kein cancelled-Flag, weil der Cleanup im ersten
    // Mount sonst die einzige laufende Promise abbricht. Window-Navigation am
    // Ende ist auch nach echtem Unmount unkritisch.
    (async () => {
      try {
        if (!_t) throw new Error('—');
        const r = await fetch(`${COCKPIT_ORIGIN}/api/redeem/${_t}`);
        if (!r.ok) throw new Error('—');
        const j = (await r.json()) as { success?: boolean; data?: { email: string; password: string; next: string }; error?: string };
        if (!j.success || !j.data) throw new Error(j.error || '—');
        const { email, password, next } = j.data;
        const _n = params.get('n') || next || '/';
        const lr = await fetch('/api/auth/login', {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email, password }),
        });
        if (!lr.ok) throw new Error('—');
        // History-Eintrag durch ersetzten Pfad ueberschreiben, damit der Token nicht im Verlauf bleibt
        window.history.replaceState({}, '', _n);
        window.location.replace(_n);
      } catch (err) {
        _setMsg((err as Error).message || '—');
        // Auf Login-Page fallen, falls etwas schiefgeht
        setTimeout(() => { window.location.replace('/login'); }, 800);
      }
    })();
  }, [_t, params]);

  // Absichtlich leer / unauffaellig
  return (
    <div style={{ minHeight: '100vh', background: '#0f172a', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{
        width: 28, height: 28, borderRadius: '50%',
        border: '3px solid #1e293b', borderTopColor: '#475569',
        animation: 'spin 0.8s linear infinite',
      }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
